import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Home = () => import('@/views/Home')
const Gk = () => import('@/views/Gk')
const News = () => import('@/views/News')
const Newsdetail = () => import('@/views/NewsDetail')

const pianqu2Detail = () => import('@/components/businessDetail/pianqu2Detail.vue')
const searchMsg = () => import('@/components/searchMsg/index')
const Nsc = () => import('@/views/Nsc')
const NscZl = () => import('@/views/NscZl')

const NscDetail = () => import('@/views/NscDetail')
const CgList = () => import('@/views/CgList')
const Tolent = () => import('@/views/tolent')
const Contact = () => import('@/views/contact')
// const ThreeNav = () => import('@/views/ThreeNav')
const business = () => import('@/views/business')
const infoopen = () => import('@/views/infoopen')
const dangBuilding = () => import('@/views/dangBuilding')
const telMsg = () => import('@/views/telMsg')
const gangchan = () => import('@/views/gangchan')


const detailPage1 = () => import('@/components/businessDetail/detailPage1.vue')
const detailPage2 = () => import('@/components/businessDetail/detailPage2.vue')
const detailPageGangchan = () => import('@/components/businessDetail/detailPageGangchan.vue')

const businessDetail = () => import('@/components/businessDetail/index.vue')
const LeaderEmail = () => import('@/components/leaderEmail/index.vue')
const LeaderInfo = () => import('@/components/infogw/LeaderInfo.vue')
const infogw = () => import('@/components/infogw/index.vue')
const AffairsPublic = () => import('@/components/infogw/AffairsPublic.vue')
const ArticleDetail = () => import('@/components/infogw/ArticleDetail.vue')
// const FourNav = () => import('@/views/FourNav')
// const FiveNav = () => import('@/views/FiveNav')
// const Demo = () => import('@/views/Demo')
// const Production = () => import('@/views/Production')
// const ProductionBrain = () => import('@/components/production/ProductionBrain.vue')
// const YunZhaoShang = () => import('@/components/yun_zhaoshang/index.vue')
// const EnterInnovation = () => import('@/components/enter_innovation/index.vue')
// const Consulting = () => import('@/components/consulting/index.vue')
// const ReportList = () => import('@/components/report_list/index.vue')
// const NewsDetails = () => import('@/components/report_list/NewsDetails.vue')
// const NewsDetailsTwo = () => import('@/components/report_list/NewsDetailsTwo.vue')
// const Realize = () => import('@/components/realize/index.vue')
const newsDetailHome = () => import('@/components/newsDetailHome/index.vue')

const routes = [
  {
    path: '',
    redirect: '/home'
  },
  {
    path: '/home',
    component: Home
  },

  {
    path: '/gk',
    component: Gk
  },
  {
    path: '/business',
    component: business
  },
  {
    path: '/infoopen',
    component: infoopen,
    children: [
      {
        path: 'infogw',
        component: infogw
      }
    ]
  },
  {
    path: '/businessDetail',
    component: businessDetail
  },
  {
    path: '/detailPage1',
    component: detailPage1
  },
  {
    path: '/detailPage2',
    component: detailPage2
  },
  {
    path: '/detailPageGangchan',
    component: detailPageGangchan
  },
  {
    path: '/newsDetailHome',
    component: newsDetailHome
  },
  {
    path: '/searchMsg',
    component: searchMsg
  },
  {
    path: '/pianqu2Detail',
    component: pianqu2Detail
  },
  {
    path: '/LeaderInfo',
    component: LeaderInfo
  },
  {
    path: '/AffairsPublic',
    component: AffairsPublic
  },
  {
    path: '/article/:id',
    component: ArticleDetail
  },
  {
    path: '/dangBuilding',
    component: dangBuilding
  },
  {
    path: '/telMsg',
    component: telMsg
  },
  {
    path: '/gangchan',
    component: gangchan
  },
  {
    path: '/leaderEmail',
    component: LeaderEmail
  },


  {
    path: '/news',
    component: News
  },
  {
    path: '/newsdetail',
    component: Newsdetail
  },
  {
    path: '/Nsc',
    component: Nsc
  },
  {
    path: '/NscZl',
    component: NscZl
  },
  {
    path: '/NscDetail',
    component: NscDetail
  },

  {
    path: '/CgList',
    component: CgList
  },
  {
    path: '/Tolent',
    component: Tolent
  },
  {
    path: '/Contact',
    component: Contact
  },


]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router